import styled, { css } from "styled-components";
import getBorderColor from "../../../../utils/getBorderColor";
import getBorderRadius from "../../../../utils/getBorderRadius";
import getBoxShadow from "../../../../utils/getBoxShadow";
import getColor from "../../../../utils/getColor";
import space from "../../../../utils/space";
import unit from "../../../../utils/unit";
import TextAtm from "../../../atoms/TextAtm";
import FlexContainerOrg from "../../../organisms/FlexContainerOrg";
export var StyledHorizontalProductBoxMol = styled.div.withConfig({
  componentId: "sc-1gewway-0"
})(function (_ref) {
  var $hasPromotionText = _ref.$hasPromotionText,
    $onColor = _ref.$onColor,
    theme = _ref.theme;
  return css(["position:relative;min-height:", ";border:", " solid ", ";box-shadow:", ";border-radius:", ";&:hover{border:", " solid ", ";}", ""], space(13), unit(1), getBorderColor(theme, $onColor, "extraLow"), getBoxShadow(theme, "nano"), getBorderRadius(theme, "mlarge"), unit(1), getBorderColor(theme, $onColor, "low"), $hasPromotionText && css(["border-radius:0 ", " ", " ", ";"], getBorderRadius(theme, "mlarge"), getBorderRadius(theme, "mlarge"), getBorderRadius(theme, "mlarge")));
});
export var PromotionText = styled(TextAtm).withConfig({
  componentId: "sc-1gewway-1"
})(function (_ref2) {
  var theme = _ref2.theme;
  return css(["position:absolute;left:", ";top:", ";background:", ";writing-mode:vertical-rl;transform:scale(-1);text-align:center;padding:", " ", ";border-radius:0 ", " ", " 0;height:auto;"], unit(-21), unit(-1), getColor(theme, "primary"), space(2), space(0.5), getBorderRadius(theme, "large"), getBorderRadius(theme, "large"));
});
export var ItemsBox = styled(FlexContainerOrg).withConfig({
  componentId: "sc-1gewway-2"
})(["flex-grow:1;padding:", " ", " ", " ", ";"], space(2), space(3), space(2), space(6));
export var RenewalPrice = styled.div.withConfig({
  componentId: "sc-1gewway-3"
})(function (_ref3) {
  var theme = _ref3.theme;
  return css(["position:absolute;right:0;bottom:0;background-color:", ";padding:", " ", ";border-radius:", " 0 ", " 0;"], getColor(theme, "background"), space(1), space(3), getBorderRadius(theme, "mlarge"), getBorderRadius(theme, "mlarge"));
});